import union from 'lodash/union'
import without from 'lodash/without'
import { APP_PROGRESS_ACTIVATE, APP_PROGRESS_DEACTIVATE } from './actions'

const initialState = {
  activators: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_PROGRESS_ACTIVATE:
      return {
        activators: union(state.activators, [action.initiator])
      }

    case APP_PROGRESS_DEACTIVATE:
      return {
        activators: without(state.activators, action.initiator)
      }

    default:
      return state
  }
}
